import styled from "styled-components";
import { theme } from "../theme";

export const StyledContainer = styled.div`
	p {
		color: red;
		text-align: center;
	}
`;

export const StyledDropContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 0;
	width: 100%;
	height: 120px;
	border: 2px dashed ${theme.color.black};
	cursor: pointer;

	input {
		display: none;
	}
`;

export const StyledUploadIcon = styled.div`
	text-align: center;
	margin: 0 auto;
	display: flex;
	justify-content: center;
	margin-bottom: 20px;

	svg {
		width: 2em;
		height: 2em;
	}
`;

export const StyledDropMessage = styled.div`
	text-align: center;
	color: ${theme.color.black};
	font-size: 14px;
`;

export const StyledFileDisplayContainer = styled.div`
	margin-top: 20px;
`;

export const StyledFileStatusBar = styled.div`
	width: 100%;
	position: relative;
	height: 50px;
	display: flex;
	align-items: center;
	justify-content: space-between;

	& > div {
		display: flex;
		align-items: center;
	}
`;

export const StyledFileType = styled.div`
	position: absolute;
	font-size: 10px;
	font-weight: 700;
	padding: 0 4px;
	margin-top: 10px;
	border-radius: 2px;
	box-shadow: 1px 1px 2px #abc;
	color: ${theme.color.white};
	background: #0080c8;
	text-transform: uppercase;
`;

export const StyledFileName = styled.span`
	display: inline-block;
	color: ${theme.color.black};
	font-size: 14px;
`;

export const StyledFileErrorMessage = styled.span`
	display: inline-block;
	margin-left: 10px;
	color: ${theme.color.red};
`;

export const StyledFileTypeLogo = styled.div`
	height: 34px;
	display: flex;
	align-items: flex-end;
	margin-right: 10px;

	svg {
		width: 3.4em;
		height: 3.4em;
	}
`;

export const StyledFileSize = styled.span`
	display: inline-block;
	vertical-align: top;
	color: #30693d;
	margin-left: 10px;
	margin-right: 5px;
	color: #444242;
	font-weight: 700;
	font-size: 14px;
`;

export const StyledFileRemove = styled.div`
	cursor: pointer;

	svg {
		width: 2em;
		height: 2em;
	}
`;

export const StyledActionButtons = styled.div`
	margin-top: 20px;
	display: flex;
	justify-content: flex-end;
`;

export const StyledErrorMessage = styled.p`
	text-align: center;
	margin-bottom: 10px;
	color: ${theme.color.red};
`;
